import * as types from "./product.types";

const initialState = {
	product_notify: null,
};

export default function product_reducer(state = initialState, action) {
	switch (action.type) {
		case types.PRODUCT_NOTIFY:
			return { ...state, product_notify: action.payload };
		case types.PRODUCT_NOTIFY_UNSET:
			return { ...state, product_notify: null };

		default:
			return state;
	}
}
